import { defineMessages } from 'react-intl';

/** Streaming → Play sources (design streaming-sections b1, b2, e2). */
export const playSourcesMessages = defineMessages({
  emptyTitle: { id: 'app.sml.streaming.playSources.empty.title', defaultMessage: 'See where your plays come from' },
  emptyText: {
    id: 'app.sml.streaming.playSources.empty.text',
    defaultMessage:
      'Your connected sources do not report where your plays come from. Connect a source that does, and MUSIC24 shows the sources of your plays for each month.',
  },
  monthLine: {
    id: 'app.sml.streaming.playSources.monthLine',
    defaultMessage: '{source} gives play sources per month.',
  },
  tileListenersAndYou: {
    id: 'app.sml.streaming.playSources.tile.listenersAndYou',
    defaultMessage: 'Listeners and you',
  },
  tileStore: { id: 'app.sml.streaming.playSources.tile.store', defaultMessage: 'The store pushed it' },
  tileOther: { id: 'app.sml.streaming.playSources.tile.other', defaultMessage: 'Other' },
  tileStreams: { id: 'app.sml.streaming.playSources.tile.streams', defaultMessage: '{count} streams' },
  rowsTitle: { id: 'app.sml.streaming.playSources.rows.title', defaultMessage: 'Where plays come from' },
  rowsCount: {
    id: 'app.sml.streaming.playSources.rows.count',
    defaultMessage: '{count, plural, one {# source of play} other {# sources of play}}',
  },
  groupYou: { id: 'app.sml.streaming.playSources.group.you', defaultMessage: 'You' },
  groupListeners: { id: 'app.sml.streaming.playSources.group.listeners', defaultMessage: 'Listeners' },
  groupStore: { id: 'app.sml.streaming.playSources.group.store', defaultMessage: 'Store' },
  groupOther: { id: 'app.sml.streaming.playSources.group.other', defaultMessage: 'Other' },
  byMonth: { id: 'app.sml.streaming.playSources.byMonth', defaultMessage: 'By month' },
  byMonthMeta: { id: 'app.sml.streaming.playSources.byMonth.meta', defaultMessage: 'Streams' },
  groupsNote: {
    id: 'app.sml.streaming.playSources.groupsNote',
    defaultMessage:
      "Listeners and you: their own playlists, their library, other listeners' playlists, your profile. The store pushed it: the store's own playlists and recommendations.",
  },
  changeNote: {
    id: 'app.sml.streaming.playSources.changeNote',
    defaultMessage: 'Change is against the same number of months before.',
  },
  withoutSplit: {
    id: 'app.sml.streaming.playSources.withoutSplit',
    defaultMessage: '{source} reports play sources for {store} only. Your streams on {stores} have no split by source.',
  },
  noRowsTitle: {
    id: 'app.sml.streaming.playSources.noRows.title',
    defaultMessage: '{source} has no play sources for {start} – {end}.',
  },
  noWholeMonthText: {
    id: 'app.sml.streaming.playSources.noWholeMonth.text',
    defaultMessage: '{source} gives play sources once a month, so this period has no numbers. Pick 90 days or more.',
  },
});
